/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPaginatedTermsServiceFileListDto } from '../../models/backend-paginated-terms-service-file-list-dto';

export interface AccountTermsServiceList$Params {
  /**
   * Number of results to return per page.
   */
  limit?: number;

  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export function accountTermsServiceList(
  http: HttpClient,
  rootUrl: string,
  params?: AccountTermsServiceList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPaginatedTermsServiceFileListDto>> {
  const rb = new RequestBuilder(rootUrl, accountTermsServiceList.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPaginatedTermsServiceFileListDto>;
    }),
  );
}

accountTermsServiceList.PATH = '/api/account/terms_service/';
